export default {
  shipping_profiles: [],
}
